module.exports = __webpack_public_path__ + "img/img3_2.186f6fbc.jpeg";